import {
  IndicatorsContainer,
  SelectContainer,
  ValueContainer,
} from "./containers";
import Control from "./control";
import Group, { GroupHeading } from "./group";
import {
  ClearIndicator,
  DropdownIndicator,
  IndicatorSeparator,
  LoadingIndicator,
} from "./indicators";
import Input from "./input";
import Menu, { LoadingMessage, MenuList, NoOptionsMessage } from "./menu";
import MultiValue, {
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
} from "./multi-value";
import Option from "./option";
import Placeholder from "./placeholder";
import SingleValue from "./single-value";

const chakraComponents = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  Group,
  GroupHeading,
  IndicatorSeparator,
  IndicatorsContainer,
  Input,
  LoadingIndicator,
  LoadingMessage,
  Menu,
  MenuList,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  NoOptionsMessage,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer,
};

export default chakraComponents;
